import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import styled, { useTheme } from "styled-components";

import { CreatePostModalContext } from "../..";
import { Divider, LabelContainer } from "../../../../../../../../commonStyles";
import { PollChoices, PollDuration } from "../../../../../../../Common";
import Input from "../../../../../../../Input";
import { CHOICE_COUNT_INITIAL_VALUE } from "../../utils";
import PollPreview from "./PollPreview";

const CreatePoll = () => {
  const { typography } = useTheme();
  const {
    choiceCount,
    setPollOpen,
    formik,
    setChoiceCount,
    setPostContentOrder,
  } = useContext(CreatePostModalContext);
  const { setFieldValue, setFieldError } = formik;

  return (
    <PollContainer id="create-poll">
      <ButtonContainer>
        <Components.IconButton
          disabled={false}
          iconType="X"
          kind="Secondary"
          size="Small"
          onClick={() => {
            setPollOpen(false);
            setPostContentOrder((prev) =>
              prev.filter((type) => type !== "poll")
            );
            const pollFields = [
              ...choiceCount.map((field) => `choice_${field}`),
              "duration",
              "question",
            ];
            pollFields.forEach((field) => {
              setFieldValue(field, "");
              setFieldError(field, undefined);
            });

            setChoiceCount(CHOICE_COUNT_INITIAL_VALUE);
          }}
        />
      </ButtonContainer>
      <Divider />

      <LabelContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text="Question"
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
      </LabelContainer>
      <Input
        fieldName="question"
        idPrefix="create-poll"
        isRequired
        placeholder="Add your question"
        size="Medium"
      />
      <Divider />
      <ChoicesAndDurationContainer $column={choiceCount.length > 5}>
        <PollChoices
          formik={formik}
          choiceCount={choiceCount}
          setChoiceCount={setChoiceCount}
        />
        <Divider $vertical={choiceCount.length < 6} />
        <PollDuration />
      </ChoicesAndDurationContainer>
      <Divider />
      <PollPreview />
    </PollContainer>
  );
};

export default CreatePoll;

const PollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
`;

const ChoicesAndDurationContainer = styled.div<{ $column: boolean }>`
  display: flex;
  flex-direction: ${({ $column }) => ($column ? "column" : "row")};
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
